import { ErrorBoundary } from "@sentry/react";
import React from "react";
import "../../assets/styles/component/documentation.scss";
import "../../assets/styles/pages/info.scss";
import { ErrorMsg } from "../AppMessages";
import { InfoMenu } from "../Menu";
import { CedarShellLayout } from "./CedarShell/CedarShellLayout";

interface Props {
  menu: JSX.Element;
  content: JSX.Element;
}

export const InfoLayout = (props: Props) => {
  const { menu, content } = props;

  return (
    <CedarShellLayout>
      <ErrorBoundary fallback={<ErrorMsg />}>
        <div className="pageWrapper" id="mainDashboard">
          {/* --menu_width zeroed out: that column was reserved for the old DashboardMenu, now
              replaced by CedarShellLayout's own sidenav. */}
          <div className="dashboard" id="infoDashboard" style={{ "--menu_width": "0" } as React.CSSProperties}>
            <div className="info_page_dashboard">
              <InfoMenu />

              <div className="info_container">
                {menu}
                <div className="info_section info_content data_documentation">{content}</div>
              </div>
            </div>
          </div>
        </div>
      </ErrorBoundary>
    </CedarShellLayout>
  );
};
